import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import KipLogo from "@/components/kip/KipLogo";

const LINKS = [
  { id: "hero", label: "Accueil" },
  { id: "about", label: "À propos" },
  { id: "metiers", label: "Nos Métiers" },
  { id: "wayne", label: "Wayne" },
  { id: "vision", label: "Vision 2030" },
  { id: "groupe", label: "Groupe" },
  { id: "contact", label: "Contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("hero");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 40);
      // active section detection
      const ids = LINKS.map((l) => l.id);
      let current = "hero";
      for (const id of ids) {
        const el = document.getElementById(id);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= 120) current = id;
        }
      }
      setActive(current);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  const darkNav = scrolled || open;

  return (
    <header
      data-testid="nav-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        darkNav ? "bg-[#1A2744] shadow-md" : "bg-transparent"
      }`}
    >
      <div className="kip-container flex items-center justify-between h-20 sm:h-24">
        <button
          onClick={() => scrollTo("hero")}
          className="flex items-center"
          data-testid="nav-logo"
          aria-label="Retour en haut"
        >
          <KipLogo variant="light" size="h-24" />
        </button>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-6 xl:gap-8">
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              data-testid={`nav-link-${l.id}`}
              className="relative text-sm font-medium text-white/85 hover:text-white transition-colors whitespace-nowrap"
            >
              {l.label}
              {active === l.id && (
                <span className="absolute -bottom-2 left-0 right-0 mx-auto w-1.5 h-1.5 rounded-full bg-[#E85D26]" />
              )}
            </button>
          ))}
          <button
            onClick={() => scrollTo("contact")}
            data-testid="nav-cta"
            className="btn-primary !py-2.5 !px-5 !text-sm whitespace-nowrap"
          >
            Nous contacter
          </button>
        </nav>

        {/* Mobile toggle */}
        <button
          className="lg:hidden text-white p-2"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {/* Mobile drawer */}
      <div
        data-testid="nav-mobile-panel"
        className={`lg:hidden overflow-hidden transition-[max-height] duration-300 bg-[#0F1A2E] ${
          open ? "max-h-[480px]" : "max-h-0"
        }`}
      >
        <div className="kip-container py-4 flex flex-col gap-1">
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              data-testid={`nav-mobile-link-${l.id}`}
              className={`text-left py-3 px-2 border-l-2 transition-colors ${
                active === l.id
                  ? "border-[#E85D26] text-white"
                  : "border-transparent text-white/75 hover:text-white"
              }`}
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo("contact")}
            className="btn-primary mt-3 w-full"
            data-testid="nav-mobile-cta"
          >
            Nous contacter
          </button>
        </div>
      </div>
    </header>
  );
}
